import { render, staticRenderFns } from "./CopyUrlButton.vue?vue&type=template&id=cf12d47a"
import script from "./CopyUrlButton.vue?vue&type=script&lang=ts"
export * from "./CopyUrlButton.vue?vue&type=script&lang=ts"
import style0 from "./CopyUrlButton.vue?vue&type=style&index=0&id=cf12d47a&prod&lang=scss"


/* normalize component */
import normalizer from "!../../../../node_modules/@vue/cli-service/node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports